<div class="task-info">
  <div class="header-element">
    <div class="task-id">{{ displayId() }}</div>
    @for (badge of badges(); track $index) {
      <div [class]="'lty-badge ' + (badge.modifier ?? 'insurance-badge')">
        @if (badge.iconUrl) {
          <img [class.insurer-logo]="badge.logo" [src]="badge.iconUrl" alt="" />
        }
        <span>{{ badge.label }}</span>
      </div>
    }
  </div>
  <div class="header-element">
    <div class="header-customer-name">{{ customerName() }}</div>
    @if (customerDisplayId()) {
      <div class="header-customer-id">{{ customerDisplayId() }}</div>
    }
    <div class="lty-badge primary">
      @if (accountType() === CustomerAccountType.PERSONAL) {
        <ng-container i18n>Privé</ng-container>
      }
      @if (accountType() === CustomerAccountType.COMPANY) {
        <ng-container i18n>Pro</ng-container>
      }
    </div>
    <div class="lty-badge purple">
      {{ getClientStatusLabel(clientStatus()) }}
    </div>
  </div>
</div>
